import React from "react";
import "./DefaultTextAreaInput.styles.scss";

const DefaultTextAreaInput = ({
  name,
  label,
  value,
  onChange,
  containerClassNames,
  labelClassNames,
  inputClassNames,
  disabled,
  copyIcon,
  copyToClipboard,
  rows = 5,
}: {
  name: string;
  label: string;
  value: string | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  containerClassNames: string;
  labelClassNames: string;
  inputClassNames: string;
  disabled?: boolean;
  copyIcon?: any;
  copyToClipboard?: (text: string, name: string) => Promise<void>;
  rows?: number;
} & Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  "onChange" | "value" | "name"
>) => {
  const inputValue = value ?? "";

  // Convert textarea change event to input event format for compatibility
  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputEvent = {
      target: {
        name,
        value: e.target.value,
      },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(inputEvent);
  };

  return (
    <div className={containerClassNames}>
      <p className={`${labelClassNames} pulse-default-text-input-label`}>
        {label}
        {copyIcon && copyToClipboard && (
          <div
            className="pulse-color--background-50 pulse-ml-1 pulse-default-text-input-copy-icon"
            onClick={() => copyToClipboard(inputValue, label)}
          >
            {copyIcon}
          </div>
        )}
      </p>
      <div className="input-icon-container">
        <textarea
          className={`input-field ${inputClassNames}`}
          name={name}
          value={inputValue}
          onChange={handleTextareaChange}
          disabled={disabled}
          rows={rows}
          style={{
            color: `${disabled ? "#627195" : "#e8eaef"}`,
            fontFamily: "monospace",
            resize: "vertical",
            width: "100%",
          }}
        />
      </div>
    </div>
  );
};

export default DefaultTextAreaInput;
